import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const SidebarHide14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M12.5303 3.03033L11.4697 1.96967L8.43933 5L11.4697 8.03033L12.5303 6.96967L10.5607 5L12.5303 3.03033Z'
      fill='currentColor'
    />
    <path d='M1 3.75H7V2.25H1V3.75Z' fill='currentColor' />
    <path d='M1 7.75H7V6.25H1V7.75Z' fill='currentColor' />
    <path d='M1 11.75V10.25H13V11.75H1Z' fill='currentColor' />
  </Svg>
);

SidebarHide14.displayName = 'SidebarHide14';
export default SidebarHide14;
